module.exports = __webpack_public_path__ + "img/digital-workflow-curved-bg.a11f4e22.png";